import {
  CHECKOUT_LOAD_ATTEMPT,
  CHECKOUT_LOAD_SUCCESS,
  CHECKOUT_LOAD_FAILED,
} from "../types/checkoutTypes";

const INITIAL_STATE = {
  loading: false,
  paymentMethod: "none",
  transfer: false,
  gateway: false,
  bankAccounts: [],
  contact: {
    Email: false,
    Phone: false,
    Chat: false,
    Whatsapp: false,
    EmailAddress: "",
    PhoneNumber: "",
  },
  seller: {},
  error: "",
};

function checkout(state = INITIAL_STATE, action) {
  switch (action.type) {
    case CHECKOUT_LOAD_ATTEMPT:
      return { ...state, loading: true, error: "" };

    case CHECKOUT_LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        paymentMethod: action.data.PaymentMethod || "none",
        transfer: Boolean(action.data.Transfer),
        gateway: Boolean(action.data.Gateway),
        bankAccounts: action.data.BankAccounts || [],
        contact: action.data.Contact || INITIAL_STATE.contact,
        seller: action.data.Seller || {},
        error: "",
      };

    case CHECKOUT_LOAD_FAILED:
      return { ...state, loading: false, error: action.error };

    default:
      return state;
  }
}

export default checkout;
